
((SmoothScroll, $) => {
  'use strict';

  const options = {};
  let $fromSelector;
  let $toSelector;

  const cacheDom = () => {
    $fromSelector = $(options.fromSelector);
    $toSelector = $(options.toSelector);
  };

  const scrollToElement = () => {
    const windowWidth = $(window).width();
    let extraOffset;
    if (windowWidth < options.mobileBreak) {
      extraOffset = options.mobileOffset;
    } else {
      extraOffset = options.desktopOffset;
    };

    $('html, body').animate({
      scrollTop: $toSelector.offset().top + extraOffset
    }, options.scrollSpeed);
  };

  const setOptions = (userOptions) => {
    options.fromSelector = userOptions.fromSelector || '.scroll-from';
    options.toSelector = userOptions.toSelector || '.scroll-to';
    options.desktopOffset = userOptions.desktopOffset || 0;
    options.mobileOffset = userOptions.mobileOffset || 0;
    options.scrollSpeed = userOptions.scrollSpeed || 1000;
    options.mobileBreak = userOptions.mobileBreak || 992;
  };

  const bindUIActions = () => {
    $fromSelector.on('click', scrollToElement);

    $('[scroll-to]').on('click', function () {
      var scrollTo = $(this).attr('scroll-to');
      var $scrollTarget = $('[scroll-position="' + scrollTo + '"]');
      var scrollOffset = $scrollTarget.offset().top - $('.main-navigation').outerHeight();
      $('html, body').animate({ scrollTop: scrollOffset }, options.scrollSpeed);
    });
  };

  const scroll = (userOptions) => {
    setOptions(userOptions);
    cacheDom();
    bindUIActions();
  };

  SmoothScroll.scroll = scroll;
})(window.SmoothScroll = window.SmoothScroll || {}, jQuery);
